/**
 * @param {*} state
 * @param {*} payload
 */
export const retrieveInformations = (state, payload) => {
  state.informations = payload
}

/**
 * @param {*} state
 * @param {*} payload
 */
export const retrieveCompanies = (state, payload) => {
  let { data } = payload

  state.companies = data
}

/**
 * @param {*} state
 * @param {*} payload
 */
export const retrieveSettings = (state, payload) => {
    state.agency = payload.jadlog_agency
}
